export default __webpack_public_path__ + "static/media/ico-azure-cloud.d5dd062b.svg";